// extracted by mini-css-extract-plugin
module.exports = {"SignupForm_buttonWrapper":"SignupForm_SignupForm_buttonWrapper__LLb_s","SignupForm_success":"SignupForm_SignupForm_success__ZUkDm"};